import styled from 'styled-components';

import { media } from 'components/_settings/variables';
import { Container } from 'components/shared/container';
import { Grid as SharedGrid } from 'components/shared/grid';
import { Title } from 'components/shared/title';

export const TriangleImage = styled.img`
  position: absolute;
  top: -8px;
  left: -201px;
  ${media.sm} {
    top: 202px;
    left: -313px;
    height: 575px;
  }
  ${media.xs} {
    height: 395px;
  }
`;

export const BackgroundImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

export const Description = styled.p`
  font-size: 20px;
  line-height: 1.6;
  color: #838791;
  margin: 0;
  white-space: pre-wrap;
  ${media.lg} {
    white-space: initial;
  }
  ${media.md} {
    white-space: pre-wrap;
  }
  ${media.sm} {
    font-size: 14px;
    line-height: 1.43;
  }
`;

export const StyledTitle = styled(Title)`
  font-size: 48px;
  font-weight: normal;
  line-height: 1.31;
  margin-bottom: 25px;
  ${media.sm} {
    font-size: 32px;
    line-height: 1.38;
    margin-bottom: 5px;
  }
  strong {
    font-weight: normal;
    color: #00c1de;
  }
`;

export const ContentLeft = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  ${media.xs} {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
  .illustration-wrapper {
    position: relative;
    height: 100%;
    width: 600px;
    ${media.lg} {
      height: 279px;
      width: 530px;
    }
    ${media.md} {
      display: flex;
      justify-content: center;
      height: 179px;
      width: 350px;
      left: -40px;
    }
    ${media.sm} {
      height: 290px;
      width: 100%;
      left: auto;
    }
    ${media.xs} {
      height: 153px;
      max-width: 320px;
    }
  }
  img {
    position: absolute;
  }
  .illustration-content {
    top: 38%;
    left: 2%;
    width: 105%;
    ${media.sm} {
      width: 100%;
    }
  }
  .illustration-content-title {
    top: 44.7%;
    left: 16.5%;
    width: 11%;
    ${media.md} {
      top: 34.7%;
    }
    ${media.sm} {
      top: 44.7%;
    }
    ${media.xs} {
      top: 24.7%;
    }
  }
  .illustration-content-desc {
    top: 54.2%;
    left: 16.5%;
    width: 30%;
    ${media.md} {
      top: 44.2%;
    }
    ${media.sm} {
      top: 54.2%;
    }
    ${media.xs} {
      top: 34.2%;
    }
  }
  .illustration-content-card {
    top: 63%;
    left: 60.4%;
    width: 33.5%;
    ${media.md} {
      top: 43%;
    }
    ${media.sm} {
      top: 53%;
      left: 55.4%;
    }
    ${media.xs} {
      top: 43%;
    }
  }
  .illustration-content-rect-one {
    top: 41%;
    left: 63%;
    width: 26%;
    ${media.md} {
      top: 21%;
    }
    ${media.sm} {
      top: 31%;
      left: 58%;
    }
    ${media.xs} {
      top: 21%;
    }
  }
  .illustration-content-rect-two {
    top: 104.3%;
    left: 63%;
    width: 14%;
    ${media.md} {
      top: 84.3%;
    }
    ${media.sm} {
      top: 94.3%;
      left: 58%;
    }
    ${media.xs} {
      top: 84.3%;
    }
  }
  .illustration-content-business {
    top: 125%;
    left: 30%;
    width: 55.3%;
  }
`;

export const ContentRight = styled.div`
  padding-top: 86px;
  padding-left: 130px;
  ${media.md} {
    padding-top: 0;
    padding-left: 0;
  }
`;

export const Grid = styled(SharedGrid)`
  > div {
    ${media.sm} {
      flex-direction: column-reverse;
    }
  }
`;

export const Inner = styled(Container)`
  position: relative;
  z-index: 1;
`;

export const Wrapper = styled.section`
  position: relative;
  padding-bottom: 235px;
  margin-bottom: 192px;
  ${media.md} {
    padding-bottom: 25px;
    margin-bottom: 122px;
  }
  ${media.sm} {
    padding-bottom: 255px;
    margin-bottom: 90px;
  }
  ${media.xs} {
    padding-bottom: 125px;
  }
`;
